import {
  PLAY_NOTIFICATION_SOUND_CHANNEL,
  type PlayNotificationSoundRequest,
} from '@electron/shared/sounds.types';

import { listenWithAbortIPC } from '@/utils/abort';

import { playSound } from './sounds';

export function playNotificationSoundsFromMain(signal: AbortSignal): void {
  listenWithAbortIPC<PlayNotificationSoundRequest>(
    PLAY_NOTIFICATION_SOUND_CHANNEL,
    ({ sound, volume }) => void playSound(sound, volume),
    signal
  );
}
